module.exports = __webpack_public_path__ + "fonts/icomoon.caa915d.woff";